import React, { useEffect, useState } from 'react';
import InputCustom from '../Auth/InputCustom';
import './../../css/table.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useFormik } from 'formik';
import * as yup from 'yup';
import '../posts/inputStyle.css';
import { useParams } from 'react-router-dom';
const EditGiftCode = () =>
{
    const [initialValues, setInitialValues] = useState([]);
    const { id } = useParams();

    useEffect(() => {
    axios
        .get(`https://arianaapp.arianaapply.com/panel/show-one-discount-code/${id}`)
        .then((res) => {
        console.log(res);
        setInitialValues(res.data);
        })
        .catch((err) => {
        console.log(err);
        });
    }, []);

    const validationSchema = yup.object({
        code: yup.string().required('وارد کردن کد تخفیف الزامیست'),
        discount: yup.string().required('وارد کردن مقدار تخفیف الزامیست'),
        description: yup.string().required('وارد کردن توضیحات تخفیف الزامیست'),
    });
    const onSubmit = (state) =>
    {
        console.log('states', state);
        const { code, discount, description } = state;
        axios.post('https://arianaapp.arianaapply.com/panel/creat-discount-code', {
            code,
            discount,
            description
        }).then(res =>{
            console.log('creat-discount-code', res);
            Swal.fire({
                title: 'کد تخفیف شما با موفقیت ویرایش شد',
                icon: 'success',
            }).then(()=>{
                window.location.reload();
            })
        }).catch(err =>{
            console.log('creat-discount-code-err', err);
            Swal.fire({
                title: 'کد تخفیف شما ویرایش نشد',
                icon: 'error',
              })
        })
    };
    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema,
        validateOnMount: true,
        enableReinitialize: true,
      });
    return (
        <div className='index'>
      <form onSubmit={formik.handleSubmit}>
      <InputCustom
                name='code'
                type='text'
                label=' کد تخفیف...'
                formikHandler={formik.getFieldProps('code')}
                formikErrors={formik.errors.code && formik.touched.code}
                formikErrorsName={formik.errors.code}
            />
            <InputCustom
                name='discount'
                type='text'
                label=' مقدار تخفیف (به درصد)...'
                formikHandler={formik.getFieldProps('discount')}
                formikErrors={formik.errors.discount && formik.touched.discount}
                formikErrorsName={formik.errors.discount}
            />
            <InputCustom
                name='description'
                type='text'
                label='توضیحات...'
                formikHandler={formik.getFieldProps('description')}
                formikErrors={formik.errors.description && formik.touched.description}
                formikErrorsName={formik.errors.description}
            />

        <div className='inputBox'>
          <button
            type='submit'
            className={!formik.isValid? 'btn-gray' : 'btn-success'}
            disabled={!formik.isValid}>
            ثبت
          </button>
        </div>
      </form>
    </div>
    );
};

export default EditGiftCode;